export const LIST_NEWS = [
  {
    content: "ACV88 - THẾ GIỚI CASINO TRONG TAY BẠN ⭐️⭐️⭐️⭐️⭐️",
  },
  {
    content:
      "📢KỶ NIỆM THÀNH LẬP ACV88 PHÁT THƯỞNG CƠN MƯA LÌ XÌ 2000 TỶ ĐỒNG.🧧",
  },
  {
    content:
      "📢ĐỒNG HÀNH CÙNG ĐẠI SỨ VILLARREAL THƯỞNG NÓNG MÙA GIẢI LA LIGA.🧧",
  },
  {
    content: "📢KỶ NIỆM THÀNH LẬP ACV88 NẠP MỖI NGÀY NHẬN THƯỞNG THÊM .🧧",
  },
  {
    content: "📢KỶ NIỆM THÀNH LẬP ACV88 THƯỞNG THÊM HOÀN TRẢ LÊN ĐẾN 100%.🧧",
  },
  {
    content: "📢KỶ NIỆM THÀNH LẬP ACV88 ĐIỂM DANH 7 NGÀY NHẬN THƯỞNG LỚN.🧧",
  },
  {
    content: "📢Khuyến mãi lớn ngày 07-17-27 hàng tháng.🧧",
  },
  {
    content: "📢Tặng nạp ngày vàng 02-12-22 không giới hạn chỉ 1 vòng cược.🧧",
  },
  {
    content: "📢Tặng nạp 100% khi nạp lần đầu tiên.Tặng 50% cho lần nạp 2.🧧",
  },
  {
    content: "📢Đầu tư sinh lời từ CASINO, phát thưởng thứ 6 hàng tuần.🧧",
  },
  {
    content:
      "📢Tích lũy cược cược tuần (NỔ HŨ-BẮN CÁ-GAME BÀI 3D), phát thưởng thứ 7 hàng tuần.🧧",
  },
  {
    content:
      "📢Giới thiệu bạn bè nhận lương trăm triệu, phát thưởng chủ nhật hàng tuần.🧧",
  },
  {
    content: "📢Bảo hiểm BACARAT 8 điểm thua 9 điểm.🧧",
  },
];
